<template>
  <v-app>
    <Header/>
    <Sidebar/>
    <v-content>
      <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
        <v-layout wrap>
          <v-flex text-xs-left xs12 md2 px-3>
            <v-autocomplete :items="filterYears" v-model="filterYearList" prepend-icon="schedule" return-object multiple @change="loadForecastSummaries" class="supplierFilter"/>
          </v-flex>
          <v-flex text-xs-left xs12 md4 px-3>
            <v-autocomplete :items="filterSuppliers" v-model="filterSupplierList" item-text="name" prepend-icon="a-factory" return-object multiple @change="loadForecastSummaries" class="supplierFilter"/>
          </v-flex>
          <v-flex text-xs-left xs12 md6>
            <v-autocomplete :items="filterFields" v-model="filterFieldList" item-text="displayName" prepend-icon="a-address" return-object multiple @change="loadForecastSummaries" class="fieldFilter"/>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-3 px-3 v-if="showForecasts">
        <v-layout style="max-height: calc(100vh - 220px);">
          <v-flex xs12 style="overflow-y: auto; padding-right: 10px;">
            <template v-for="(forecastSummaries, i) in yearForecastSummaries">
              <v-flex xs12 class="panelTitle" :style="i > 0 ? 'margin-top: 10px;' : ''" :key="'forecast_title_' + i">{{ 'Forecast ' + forecastSummaries[0].year }}</v-flex>

              <v-flex xs12 :key="'forecast_table_' + i">
                <v-data-table :headers="isCurrentProduction(forecastSummaries[0].year) ? tableHeaderCurrentSeason : tableHeader(forecastSummaries[0].year)" :items="forecastSummaries" hide-actions no-data-text="No forecast data found" class="salesTable forecastTable" :key="i + '_' + updateCounter" style="border: 1px solid #DDDDDD; border-radius: 3px; margin-bottom: 20px;">
                  <template v-slot:items="props">
                    <tr :class="rowClass(props.item)" v-if="showItem(props.item)">
                      <td class="text-xs-left" style="width: 15px; padding-left: 5px !important; padding-right: 0 !important; padding-top: 2px !important; padding-bottom: 0 !important;'">
                        <v-icon style="font-size: 20px;" v-if="showExpandIcon(props.item)" @click="yearFamilyClicked(props.item)">chevron_right</v-icon>
                        <v-icon style="font-size: 20px;" v-if="showCollapseIcon(props.item)" @click="yearFamilyClicked(props.item)">expand_more</v-icon>
                      </td>
                      <td class="text-xs-left" @click="yearFamilyClicked(props.item)" style="width: 20px; padding-left: 4px !important; padding-right: 0 !important; cursor: pointer;">
                        <div v-if="showFamily(props.item)" style="padding-top: 1px;">
                          <div v-if="props.item.family && props.item.family.color && !(props.item.family.color.secondColor && props.item.family.color.secondColor !== '')" :style="'margin: 3px 5px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + props.item.family.color.color + ';'"></div>
                          <div v-if="props.item.family && props.item.family.color && props.item.family.color.secondColor && props.item.family.color.secondColor !== ''" :style="'margin: 3px 5px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + props.item.family.color.color + ', #' + props.item.family.color.color + ' 3px, #' + props.item.family.color.secondColor + ' 3px, #' + props.item.family.color.secondColor + ' 6px);'"></div>
                        </div>
                      </td>
                      <td class="text-xs-left" style="width: 300px; white-space: nowrap; padding-right: 20px !important;">
                        <div v-if="showFamily(props.item)" @click="yearFamilyClicked(props.item)" style="padding-top: 2px; cursor: pointer;">
                          {{ props.item.family.displayLabel }}
                        </div>
                        <div v-if="showField(props.item)" class="field">
                          {{ props.item.field.displayName }}
                        </div>
                        <div v-if="showSubTotal(props.item)" class="subTotal">
                          Subtotal
                        </div>
                        <div v-if="showTotal(props.item)" class="total">
                          Total
                        </div>
                      </td>
                      <td class="text-xs-right amount" style="width: 140px !important; padding-right: 20px !important;">{{ props.item.amount ? props.item.amount.toLocaleString() : '' }}</td>
                      <td class="text-xs-right amount" style="width: 120px !important; padding-right: 20px !important;" v-if="isCurrentProduction(forecastSummaries[0].year)">{{ props.item.labelled ? props.item.labelled.toLocaleString() : '' }}</td>
                      <td class="text-xs-right amount" style="width: 140px !important; padding-right: 20px !important;" v-if="isCurrentProduction(forecastSummaries[0].year)">{{ props.item.adjustedAmount ? props.item.adjustedAmount.toLocaleString() : showField(props.item) ? '0' : '' }}</td>
                      <td class="text-xs-right amount" style="width: 120px !important; padding-right: 15px !important;" v-if="isCurrentProduction(forecastSummaries[0].year)">{{ showExtendedInformation(props.item) && props.item.ordered ? props.item.ordered.toLocaleString() : '' }}</td>
                      <td class="text-xs-right amount" style="width: 120px !important; padding-right: 12px !important;" v-if="isCurrentProduction(forecastSummaries[0].year) && deviationModeLabelled">{{ showExtendedInformation(props.item) && props.item.amount >= 0 && props.item.labelled >= 0 ? (props.item.amount - props.item.labelled).toLocaleString() : '' }}</td>
                      <td class="text-xs-right amount" style="width: 120px !important; padding-right: 12px !important;" v-if="isCurrentProduction(forecastSummaries[0].year) && deviationModeOrdered">{{ showExtendedInformation(props.item) && props.item.adjustedAmount >= 0 && props.item.ordered >= 0 ? (props.item.adjustedAmount - props.item.ordered).toLocaleString() : '' }}</td>
                      <td></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </template>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <Footer/>
  </v-app>
</template>

<script>
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'Forecast',
  components: { Header, Sidebar, Footer },
  data () {
    return {
      forecastOverview: false,
      // forecastSummaries: [],
      yearForecastSummaries: [],
      filterYears: [],
      filterYearList: [],
      filterSuppliers: [],
      filterSupplierList: [],
      filterFields: [],
      filterFieldList: [],
      deviationMode: 'ORDERED',
      expandedYearFamilies: new Map(),
      updateCounter: 0
    }
  },
  created: function () {
    this.$store.dispatch('page/setSidebarItem', {key: 'forecast'})
    this.loadForecastSummaries()
    this.loadFilterYears()
    this.loadFilterSuppliers()
    this.loadFilterFields()
  },
  computed: {
    showForecasts: function () {
      return this.forecastOverview && this.activeProduction !== null
    },
    activeProduction: function () {
      return this.$store.getters['session/getActiveProduction']
    },
    tableHeaderCurrentSeason: function () {
      if (this.activeProduction) {
        // let currentYear = Number(this.activeProduction.name)
        return [
          { text: '', sortable: false },
          { text: '', sortable: false },
          { text: 'Category family', value: 'family.displayLabel', sortable: false },
          { text: 'Forecast', value: 'amount', align: 'right', sortable: false },
          { text: 'Labelled', value: 'labelled', align: 'right', sortable: false },
          { text: 'Adj. forecast', value: 'adjustedAmount', align: 'right', sortable: false },
          { text: 'Ordered', value: '', align: 'right', sortable: false },
          { text: 'Status', value: 'deviation', align: 'right', sortable: false }
        ]
      }
      return []
    },
    deviationModeOrdered () {
      return this.deviationMode === 'ORDERED'
    },
    deviationModeLabelled () {
      return this.deviationMode === 'LABELLED'
    },
    buttonStyleDeviationOrdered () {
      return this.deviationModeOrdered ? ' color: #606060 !important;' : ''
    },
    buttonStyleDeviationLabelled () {
      return this.deviationModeLabelled ? ' color: #606060 !important;' : ''
    },
    ...mapGetters({
      sessionSalesOrganizations: 'session/getSalesOrganizations'
    })
  },
  methods: {
    tableHeader (year) {
      return [
        { text: '', sortable: false },
        { text: '', sortable: false },
        { text: 'Category family', value: 'family.displayLabel', sortable: false },
        { text: 'Forecast ' + year, value: 'amount', align: 'right', sortable: false }
      ]
    },
    async loadForecastSummaries () {
      this.yearForecastSummaries = []
      this.forecastOverview = false
      let years = []
      for (let y of this.filterYearList) {
        years.push(y)
      }
      let supplierIds = []
      for (let s of this.filterSupplierList) {
        supplierIds.push(s.id)
      }
      let fieldIds = []
      for (let f of this.filterFieldList) {
        fieldIds.push(f.id)
      }
      let params = ''
      if (years.length > 0) {
        params += (params !== '' ? '&' : '?')
        params += 'years=' + years.join(',')
      }
      if (supplierIds.length > 0) {
        params += (params !== '' ? '&' : '?')
        params += 'suppliers=' + supplierIds.join(',')
      }
      if (fieldIds.length > 0) {
        params += (params !== '' ? '&' : '?')
        params += 'fields=' + fieldIds.join(',')
      }
      await axios.get('/backend/rest/forecast/summary' + params)
        .then(response => {
          this.yearForecastSummaries = []
          let forecastSummaries = response.data
          if (forecastSummaries) {
            let lastYear = null
            let summaries = []
            let total = 0
            let totalAdjusted = 0
            let labelledPreviousYearTotal = 0
            let deliveredPreviousYearTotal = 0
            let orderedPreviousYearTotal = 0
            let labelledTotal = 0
            let orderedTotal = 0
            let rowIndex = 0

            for (let summary of forecastSummaries) {
              if (lastYear && lastYear !== summary.year) {
                summaries.push({
                  subTotal: false,
                  type: 'total',
                  amount: total,
                  adjustedAmount: totalAdjusted,
                  labelledPreviousYear: labelledPreviousYearTotal,
                  deliveredPreviousYear: deliveredPreviousYearTotal,
                  orderedPreviousYear: orderedPreviousYearTotal,
                  labelled: labelledTotal,
                  ordered: orderedTotal,
                  rowIndex: rowIndex
                })

                this.yearForecastSummaries.push(summaries)
                summaries = []
                total = 0
                totalAdjusted = 0
                labelledPreviousYearTotal = 0
                deliveredPreviousYearTotal = 0
                orderedPreviousYearTotal = 0
                labelledTotal = 0
                orderedTotal = 0
                rowIndex = 0
              }

              summary.rowIndex = rowIndex

              summaries.push(summary)

              if (summary.subTotal) {
                total += summary.amount
              }
              if (summary.subTotal) {
                totalAdjusted += summary.adjustedAmount
              }
              if (summary.family && !summary.field && !summary.subTotal && summary.labelledPreviousYear) {
                labelledPreviousYearTotal += summary.labelledPreviousYear
              }
              if (summary.family && !summary.field && !summary.subTotal && summary.deliveredPreviousYear) {
                deliveredPreviousYearTotal += summary.deliveredPreviousYear
              }
              if (summary.family && !summary.field && !summary.subTotal && summary.orderedPreviousYear) {
                orderedPreviousYearTotal += summary.orderedPreviousYear
              }
              if (summary.family && !summary.field && !summary.subTotal && summary.labelled) {
                labelledTotal += summary.labelled
              }
              if (summary.family && !summary.field && !summary.subTotal && summary.ordered) {
                orderedTotal += summary.ordered
              }
              if (summary.subTotal) {
                rowIndex++
              }

              lastYear = summary.year
            }

            if (summaries.length) {
              summaries.push({
                subTotal: false,
                type: 'total',
                amount: total,
                adjustedAmount: totalAdjusted,
                labelledPreviousYear: labelledPreviousYearTotal,
                deliveredPreviousYear: deliveredPreviousYearTotal,
                orderedPreviousYear: orderedPreviousYearTotal,
                labelled: labelledTotal,
                ordered: orderedTotal,
                rowIndex: rowIndex
              })

              this.yearForecastSummaries.push(summaries)
            }
          }
          this.forecastOverview = true
        })
    },
    loadFilterYears () {
      axios.get('/backend/rest/forecast/years')
        .then(response => {
          this.filterYears = response.data
        })
    },
    loadFilterSuppliers () {
      axios.get('/backend/rest/supplier')
        .then(response => {
          this.filterSuppliers = response.data
        })
    },
    loadFilterFields () {
      axios.get('/backend/rest/field')
        .then(response => {
          this.filterFields = response.data
          this.filterFields.sort(function (f1, f2) {
            return f1.displayName.localeCompare(f2.displayName)
          })
        })
    },
    showFamily (summary) {
      return summary.family && !summary.field && !this.showSubTotal(summary)
    },
    showField (summary) {
      return summary.field
    },
    rowClass (summary) {
      let cls = this.showFamily(summary) || this.showField(summary) ? 'field' : this.showSubTotal(summary) ? 'subTotal' : 'total'
      cls += ' ' + (summary.rowIndex % 2 === 0 ? 'evenSummary' : 'oddSummary')
      return cls
    },
    showItem (summary) {
      return this.showFamily(summary) || (summary.family && this.expandedYearFamilies.get(summary.year + '_' + summary.family.id)) || summary.type === 'total'
    },
    showSubTotal (summary) {
      return summary.subTotal
    },
    showTotal (summary) {
      return summary.type === 'total'
    },
    showExpandIcon (summary) {
      return this.showFamily(summary) && !this.expandedYearFamilies.get(summary.year + '_' + summary.family.id) && !(summary.type === 'total')
    },
    showCollapseIcon (summary) {
      return this.showFamily(summary) && this.expandedYearFamilies.get(summary.year + '_' + summary.family.id) && !(summary.type === 'total')
    },
    showExtendedInformation (summary) {
      return !summary.field && !summary.subTotal
    },
    yearFamilyClicked (summary) {
      let expanded = this.expandedYearFamilies.get(summary.year + '_' + summary.family.id)
      expanded = !expanded
      this.expandedYearFamilies.set(summary.year + '_' + summary.family.id, expanded)
      this.updateCounter++
    },
    isCurrentProduction (year) {
      return year.toString() === (this.activeProduction ? this.activeProduction.name : '')
    },
    setDeviationModeOrdered () {
      this.deviationMode = 'ORDERED'
    },
    setDeviationModeLabelled () {
      this.deviationMode = 'LABELLED'
    }
  },
  watch: {
    sessionSalesOrganizations () {
      this.loadForecastSummaries()
      this.loadFilterYears()
      this.loadFilterSuppliers()
      this.loadFilterFields()
    }
  }
}
</script>
<style scoped>
html {
  overflow-y: auto;
}
tr.total td.amount,
tr.field td.amount {
  padding-right: 18px !important;
  padding-top: 2px !important;
}
tr td.category:not(:first-child) {
  width: 200px;
  padding-right: 25px !important;
}
tr td.amount:not(:first-child) {
  padding: 2px 10px !important;
}
tr td.category,
tr td.amount {
  white-space: nowrap;
}
tr.field td div.field,
tr.field td.amount {
}
tr.field td div.field {
  padding-left: 10px;
}
tr.total td.total,
tr.total td.amount {
  padding-top: 2px !important;
}
tr.subTotal td,
tr.total td {
  font-weight: bold;
  color: rgba(0, 0, 0, 0.54);
}
tr.subTotal td.category,
tr.subTotal td.amount {
  padding-bottom: 10px !important;
}
tr.total td div.total,
tr.total td.amount {
  padding-top: 10px !important;
}
tr.subTotal td div.subTotal {
  padding-top: 2px !important;
  text-align: left;
}
.forecastTable tr.oddSummary {
  background-color: rgba(0, 77, 64, 0.02) !important;
}
.forecastTable tr.oddSummary:hover {
  background-color: rgba(0, 77, 64, 0.05) !important;
}
.forecastTable tr.evenSummary {
  background-color: #ffffff !important;
}
.forecastTable tr.evenSummary:hover {
  background-color: #fafafa !important;
}
.panelTitle {
  padding: 10px 0 0 0;
  font-weight: bold;
  font-size: 12pt;
  font-style: normal;
  color: #004d40;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Forecast.vue